import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { Box, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import withFieldPermissions, { WithFieldPermissionsProps } from '../../../withFieldPermissions'

const FIELD_NAME = 'roundTrip'
interface Props extends WithFieldPermissionsProps {}

const RoundTripField = (props: Props) => {
  const { control, setValue, watch } = useFormContext()
  const { isFieldReadOnly } = props
  const mileage = watch('mileage')

  const handleMileageRoundTripChange = (value: boolean) => {
    if (value) {
      setValue('mileage', mileage * 2)
    } else {
      setValue('mileage', mileage / 2)
    }
  }
  return (
    <Box width="full">
      <Controller
        control={control}
        name={FIELD_NAME}
        render={({ field }) => (
          <TogglerCheckbox
            {...field}
            label={i18n.t('expenses_v2.forms.fields.round_trip.label')}
            onChange={(value) => {
              field.onChange(value)
              if (mileage) {
                handleMileageRoundTripChange(value)
              }
            }}
            disabled={isFieldReadOnly}
          />
        )}
      />
    </Box>
  )
}

export default withFieldPermissions(RoundTripField, FIELD_NAME)
